import myStyle from "../cim-sub-menu.module.css";
import tracking from "frontend/tracking";
import { useEffect } from "react";

const BackArrow = ({ color = "#AFB3BF" }: { color?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
      <path
        d="M3.63676 0.5L0.559609 4.19258C0.480141 4.28795 0.480141 4.42646 0.559609 4.52183L3.63676 8.21441"
        stroke={color}
        strokeLinecap="round"
      />
      <line x1="0.563049" y1="4.34302" x2="12.4204" y2="4.34302" stroke="#AFB3BF" strokeLinecap="round" />
    </svg>
  );
};

export default function SubSubMenu({
  children,
  onGoBack,
  subMenuType,
  hideBackButton = false,
}: {
  children: React.ReactNode;
  onGoBack: () => void;
  subMenuType: string;
  hideBackButton?: boolean;
}) {
  useEffect(() => {
    tracking.trackAnalyticsEvent("cim_sub_sub_menu_viewed", {
      sub_menu_type: subMenuType,
    });
  }, [subMenuType]);

  return (
    <>
      {!hideBackButton && (
        <button
          className={myStyle.buttonReset}
          style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            width: "13px",
            height: "9px",
            display: "grid",
            zIndex: 1001,
            placeContent: "center",
          }}
          onClick={onGoBack}
        >
          <BackArrow />
        </button>
      )}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: "15px",
          background: "#fff",
          zIndex: 1000,
        }}
      >
        {children}
      </div>
    </>
  );
}
